module.exports = __webpack_public_path__ + "assets/img/Dark.99ead32e.svg";